import { atom } from 'jotai';

import { assetDetailQueryAtom } from '../_graphql/queryAssetDetail';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

type AssetDetailTab = 'details';

// 🟣🟣🟣 PARAMS
const $detailsPathParams = atomFromRoutePath(
  '/transportation/assets/:assetId' as const,
);

export const $tab = atomFromQueryString.string<AssetDetailTab>(
  'tab',
  'details',
);

// 🟢🟢🟢 COMPUTED DATA -> asset ID
export const $assetId = atom((get) => String(get($detailsPathParams)?.assetId));

// 🟢🟢🟢 REMOTE DATA
export const $remoteAsset = assetDetailQueryAtom((get) => ({
  variables: {
    ids: [get($assetId)],
  },
  skip: !get($assetId),
}));

// 🟢🟢🟢 COMPUTED DATA -> selected asset
export const $selectedAsset = atom((get) =>
  get($remoteAsset).data?.assets.at(0),
);
